import { render, staticRenderFns } from "./DataManagerJobs.vue?vue&type=template&id=551a72fd&"
import script from "./DataManagerJobs.vue?vue&type=script&lang=js&"
export * from "./DataManagerJobs.vue?vue&type=script&lang=js&"
import style0 from "./DataManagerJobs.vue?vue&type=style&index=0&id=551a72fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports